export const SCREEN_WIDTH = window.innerWidth < 1200 ? true : false;
export const SCREEN_MAX_WIDTH = '1200px';

export const dev = 'dev';
export const isDev = process.env.REACT_APP_ENV === dev;

export const demo = 'demo';
export const isDemo = process.env.REACT_APP_ENV === demo;

export const prod = 'prod';
export const isProd = process.env.REACT_APP_ENV === prod;